<template>
  <div id="commercial-service-booking-detail-information-page">
    <v-container fluid class="px-0">
      <template>
        <v-row>
          <v-col cols="12" class="pt-4 pb-1">
            <strong class="section-title">ข้อมูลผู้แจ้ง</strong>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" class="py-1">
            <span class="label-text"
              >ชื่อ : {{ booking.requester.contactName }}</span
            >
          </v-col>
          <template v-if="getEnv === 'lpa'">
            <v-col cols="12" md="6" class="py-1">
              <span class="label-text"
                >โครงการ : {{ booking.requester.projectName }}</span
              >
            </v-col>
            <v-col cols="12" md="6" class="py-1">
              <span class="label-text"
                >เลขที่ยูนิต : {{ booking.requester.unitId }}</span
              >
            </v-col>
          </template>
          <v-col cols="12" md="6" class="py-1">
            <span class="label-text"
              >อีเมล : {{ booking.requester.email || "-" }}</span
            >
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <span class="label-text"
              >เบอร์โทรติดต่อ : {{ booking.requester.tel || "-" }}</span
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </template>

      <template>
        <v-row>
          <v-col cols="12" class="pt-4 pb-1">
            <strong class="section-title">ข้อมูลผู้รับบริการ</strong>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="py-1">
            <span class="label-text"
              >ชื่อ : {{ booking.contactor.contactName }}</span
            >
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <span class="label-text"
              >วันที่นัด :
              <span class="bc--current">{{
                getDisplayTime(booking.contactor.appointedAt)
              }}</span></span
            >
          </v-col>

          <v-col cols="12" md="6" class="py-1">
            <span class="label-text"
              >อีเมล : {{ booking.contactor.email || "-" }}</span
            >
          </v-col>

          <v-col cols="12" md="6" class="py-1">
            <span class="label-text"
              >เบอร์โทรติดต่อ : {{ booking.contactor.tel || "-" }}</span
            >
          </v-col>

          <v-col cols="12" md="6" class="py-1">
            <span class="label-text"
              >ที่อยู่ : {{ booking.contactor.address }}</span
            >
          </v-col>

          <v-col cols="12" md="6" class="py-1">
            <span class="label-text"
              >หมายเหตุ : {{ booking.contactor?.note || "-" }}</span
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </template>

      <template>
        <v-row>
          <v-col cols="12" class="pt-2 pb-1">
            <strong class="section-title">ข้อมูลการซื้อขาย</strong>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" class="py-1">
            <span class="label-text"
              >ชื่อบริษัท : {{ booking.summary.vendorName }}</span
            >
          </v-col>
          <v-col cols="12" md="4" class="py-1">
            <span class="label-text"
              >อีเมล : {{ booking.summary.email || "-" }}</span
            >
          </v-col>
          <v-col cols="12" md="4" class="py-1">
            <span class="label-text"
              >เบอร์โทรศัพท์ : {{ booking.summary.tel || "-" }}</span
            >
          </v-col>
        </v-row>
      </template>

      <template
        v-if="!this.$vuetify.breakpoint.sm && !this.$vuetify.breakpoint.xs"
      >
        <v-row>
          <v-col cols="12">
            <div style="background-color: white">
              <v-data-table
                class="row-pointer"
                :headers="vTableHeaders"
                :items="booking.summary.items"
                multi-sort
                hide-default-footer
                disable-pagination
              >
                <template v-slot:[`item.price`]="{ item }">
                  <span>{{ getCurrency(item.price) }} &#3647;</span>
                </template>
                <template slot="body.append">
                  <tr>
                    <td><strong>ยอดรวมทั้งหมด</strong></td>
                    <td></td>
                    <td></td>
                    <td>
                      <strong
                        >{{
                          getTotalPrice(booking.summary.items)
                        }}
                        &#3647;</strong
                      >
                    </td>
                  </tr>
                </template>
                <template v-slot:no-data>
                  <b>ไม่พบข้อมูล</b>
                </template>
              </v-data-table>
              <v-divider></v-divider>
            </div>
          </v-col>
        </v-row>
      </template>

      <template v-else>
        <v-row
          v-for="category in Object.keys(getCategoriesMobile())"
          :key="category"
        >
          <v-col cols="12">
            <span class="item-title">{{ category }}</span>
          </v-col>
          <v-col
            cols="12"
            v-for="(item, key) in getCategoriesMobile()[category]"
            :key="key"
          >
            <!-- <span>{{ item.vendorItem }}</span> -->
            <v-row no-gutters align="center" justify="center">
              <v-col cols="2">
                <v-card
                  outlined
                  class="d-flex justify-center align-center square"
                >
                  <span class="item-desc">{{ item.quantity }}</span>
                </v-card>
              </v-col>
              <v-col cols="7">
                <span class="item-desc">{{ item.vendorItem }}</span>
              </v-col>
              <v-col cols="3" class="text-right">
                <span class="item-price"
                  >{{ getCurrency(item.price) }} &#3647;</span
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </v-col>
          <!-- <v-col cols="12">
            <v-row no-gutters align="center" justify="center">
              <v-col cols="2">
                <v-card outlined class="d-flex justify-center align-center square">
                  <span class="item-desc">{{ value.quantity }}</span>
                </v-card>
              </v-col>
              <v-col cols="7">
                <span class="item-desc">{{ value.vendorItem }}</span>
              </v-col>
              <v-col cols="3" class="text-right">
                <span class="item-price">{{ getCurrency(value.price) }} &#3647;</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </v-col> -->
        </v-row>
        <v-row>
          <v-col cols="8">
            <span class="item-desc">ยอดรวมทั้งหมด</span>
          </v-col>
          <v-col cols="4" class="text-right">
            <span class="item-price font-weight-bold"
              >{{ getTotalPrice(booking.summary.items) }} &#3647;</span
            >
          </v-col>
        </v-row>
      </template>

      <template v-if="booking?.platformRevenue?.total">
        <v-row>
          <v-col cols="12" class="pt-2 pb-1">
            <strong class="section-title"
              >ข้อมูลการได้รับเงินจากแพลทฟอร์ม</strong
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="py-1">
            <span class="label-text"
              >จำนวนเงินที่จะได้รับ (บาท) :
              {{
                booking?.platformRevenue?.total
                  ? getCurrency(booking?.platformRevenue?.total)
                  : "-" || "-"
              }}</span
            >
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <span class="label-text"
              >ค่าธรรมเนียมแพลทฟอร์ม (บาท) :
              <div class="text-accent-color">
                {{
                  booking?.platformRevenue?.platformFee
                    ? getCurrency(booking?.platformRevenue?.platformFee)
                    : "-" || "-"
                }}
              </div>
            </span>
          </v-col>
        </v-row>
      </template>

      <template v-if="booking?.payeeAccountInformation?.accountNo">
        <v-row>
          <v-col cols="12" class="pt-2 pb-1">
            <strong class="section-title">ข้อมูลบัญชีรับเงิน</strong>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="py-1">
            <span class="label-text"
              >ชื่อเรียกบัญชี :
              {{ booking?.payeeAccountInformation?.accountName || "-" }}</span
            >
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <span class="label-text"
              >ธนาคาร :
              {{ booking?.payeeAccountInformation?.bankDisplay || "-" }}</span
            >
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <span class="label-text"
              >ประเภทบัญชี :
              {{
                booking?.payeeAccountInformation?.accountTypeDisplay || "-"
              }}</span
            >
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <span class="label-text"
              >เลขที่บัญชี :
              {{ booking?.payeeAccountInformation?.accountNo || "-" }}</span
            >
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </template>

      <template v-if="booking?.paymentInformation?.paymentStatus">
        <v-row>
          <v-col cols="12" class="pt-2 pb-1">
            <strong class="section-title">ข้อมูลการชำระเงินของลูกค้า</strong>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" class="py-1">
            <span class="label-text"
              >สถานะการชำระเงิน :
              <div class="text-accent-color">
                {{ booking?.paymentInformation?.paymentStatus }}
              </div>
            </span>
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <span class="label-text"
              >ช่องทางการชำระเงิน :
              <div class="text-accent-color">
                {{ booking?.paymentInformation?.paymentMethodDisplay || "-" }}
              </div>
            </span>
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <span class="label-text"
              >วันเวลาชำระเงิน :
              <div class="text-accent-color">
                {{
                  booking?.paymentInformation?.paidAt
                    ? getDisplayTime(booking?.paymentInformation?.paidAt)
                    : "-" || "-"
                }}
              </div>
            </span>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </template>

      <!-- <template v-if="booking?.cancelInformation">
        <v-row>
          <v-col cols="12" class="pt-2 pb-1">
            <strong class="section-title">ข้อมูลการยกเลิก</strong>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" class="py-1">
            <span class="label-text"
              >ค่าธรรมเนียมการยกเลิก (บาท) :
              {{
                booking?.cancelInformation?.cancelFee
                  ? getCurrency(booking?.cancelInformation?.cancelFee)
                  : "-" || "-"
              }}</span
            >
          </v-col>
        </v-row>

        <template v-if="booking?.cancelInformation?.cancelReason">
          <v-row>
            <v-col cols="12" md="12" class="py-1">
              <v-card
                v-if="booking?.cancelInformation?.cancelReason"
                color="#FAFAFA"
                elevation="0"
                class="py-2 px-4 mt-6 mb-4"
                style="border: 1px solid #eaeaea"
              >
                <v-row no-gutters>
                  <v-col cols="12" class="pt-2 pb-1">
                    <strong class="section-title rejected-text-color"
                      >เหตุผลการยกเลิก</strong
                    >
                  </v-col>
                  <v-col cols="12" class="pt-2 pb-1">
                    <span class="label-text rejected-text-color">{{
                      booking?.cancelInformation?.cancelReason
                    }}</span>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </template> -->

      <v-card
        v-if="booking.rejectReason"
        color="#FAFAFA"
        elevation="0"
        class="py-2 px-4 mt-6 mb-4"
        style="border: 1px solid #eaeaea"
      >
        <v-row no-gutters>
          <v-col cols="12" class="pt-2 pb-1">
            <strong class="section-title rejected-text-color"
              >เหตุผลการยกเลิก</strong
            >
          </v-col>
          <v-col cols="12" class="pt-2 pb-1">
            <span class="label-text rejected-text-color">{{
              booking.rejectReason
            }}</span>
          </v-col>
        </v-row>
      </v-card>

      <v-card
        v-if="booking.rating"
        color="#FAFAFA"
        elevation="0"
        class="py-2 px-4 mt-6 mb-4"
        style="border: 1px solid #eaeaea"
      >
        <v-row no-gutters>
          <v-col cols="12" class="pt-2 pb-1">
            <strong class="section-title">คะแนนรีวิว</strong>
          </v-col>
          <v-col cols="12" class="pt-2 pb-1">
            <span class="label-text"
              ><v-icon class="mr-1" color="#FFD233">mdi-star</v-icon>
              <span style="color: #0163e0"
                >{{ booking.rating }} / 5 -
                {{ booking.comment || "ไม่มีข้อความรีวิว" }}</span
              ></span
            >
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { toCurrency } from "@/filters/decimal.filter";

export default {
  computed: {
    ...mapGetters(["bookingLoading"]),
    getEnv() {
      // return this.$route.params.env;
      return this.$route.meta.env;
    },
  },
  props: {
    data: {
      type: Object,
    },
    booking: {
      type: Object,
    },
  },
  data() {
    return {
      isPageLoading: false,
      pageLimit: 20,
      pages: 0,
      page: 1,
      vTableHeaders: [
        {
          text: "ชื่อบริการ",
          value: "category",
        },
        { text: "ชื่อสินค้า", value: "vendorItem" },
        { text: "จำนวน", value: "quantity" },
        { text: "ราคา (บาท)", value: "price" },
      ],
      list: [
        {
          categoryName: "บริการล้างแอร์แบบธรรมดา",
          categoryItemName: "แอร์ติดผนัง - 24,000 BTU+",
          qty: 1,
          summaryPrice: "1,000.00",
        },
        {
          categoryName: "บริการล้างแอร์แบบธรรมดา",
          categoryItemName: "แอร์ฝังผ้า - 9,000 - 36,000 BTU+",
          qty: 1,
          summaryPrice: "1,450.00",
        },
      ],
      categoryHeaders: [],
    };
  },
  created() {
    // console.log('created data', this.data);
    console.log("this.$vuetify.breakpoint.sm", this.$vuetify.breakpoint.sm);
    console.log("this.$vuetify.breakpoint.md", this.$vuetify.breakpoint.md);
  },
  methods: {
    getCurrency(price) {
      return toCurrency(price);
    },
    getTotalPrice(list) {
      return this.getCurrency(
        list.map((v) => v.price).reduce((partialSum, a) => partialSum + a, 0),
      );
    },
    getDisplayTime(dateTime) {
      return (
        moment
          .utc(dateTime)
          .local()
          .locale("th")
          .format("DD MMM YYYY, HH:mm น.") || "-"
      );
    },
    getCategoriesMobile() {
      const bookingItems = this.booking.summary.items;
      const categories = [];
      bookingItems.forEach((booking) => {
        const categoryHeader = booking.category;
        if (!categories[categoryHeader]) {
          categories[categoryHeader] = [];
        }
        categories[categoryHeader].push(booking);
      });

      return categories;

      // console.log('categories', categories);

      // const elements = Object.keys(categories).map(function(k) {
      //   return categories[k];
      // })
      // console.log('elements', elements);

      // return elements;
    },
  },
};
</script>
<style lang="scss" scoped>
.section-title {
  font-size: 18px;
  color: black;
}
.label-text {
  font-size: 16px;
  color: black;
}
.rejected-text-color {
  color: #d74949;
}
.item-title {
  color: #022555;
  font-size: 16px;
  font-weight: bold;
}
.item-desc {
  color: #022555;
  font-size: 14px;
  font-weight: bold;
}
.item-price {
  color: black;
  font-size: 14px;
}
.square {
  height: 32px;
  width: 32px;
}

.text-accent-color {
  color: #1976d2;
}
// @media only screen and (max-width: 959.98px) {
//   .section-title {
//     display: flex;
//     width: 100%;
//     justify-content: center;
//   }
// }
</style>
